<template>
	<div>
		<h1>Investigators</h1>

		<InputTextSingleLineMulti
			question="Who are the investigators in the study?"
			v-model="$tera.project.author"
			placeholder="e.g. Justin Clark"
			bookmark="study-investigators"
		/>

		<InputTextSingleLineMulti
			question="Who else helped with the study? (Acknowledgements)"
			v-model="$tera.project.acknowledgements"
			placeholder="e.g. Justin Clark"
			bookmark="study-help"
		/>
	</div>
</template>
<script>
import InputTextSingleLineMulti from "@/components/InputTextSingleLineMulti.vue";

export default {
	name: "ViewTitlePagePeople",
	components: {
		InputTextSingleLineMulti
	}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
